/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Gameplayalt1Inputs */

const id_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gameplay LEGO Star Wars`)
};

const ms_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan LEGO Star Wars`)
};

const da_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const de_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const en_us2_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const es_es2_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugabilidad de LEGO Star Wars`)
};

const es_mx2_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugabilidad de LEGO Star Wars`)
};

const fil_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const fr_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gameplay LEGO Star Wars`)
};

const it_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gameplay LEGO Star Wars`)
};

const hu_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars játékmenet`)
};

const nl_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const no_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Gameplay`)
};

const pl_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozgrywka LEGO Star Wars`)
};

const pt_br2_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Jogabilidade`)
};

const pt_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogabilidade LEGO Star Wars`)
};

const ro_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gameplay LEGO Star Wars`)
};

const fi_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars -pelaaminen`)
};

const sv_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars-gameplay`)
};

const vi_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gameplay LEGO Star Wars`)
};

const tr_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Oynanış`)
};

const cs_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars Hraní`)
};

const bg_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars геймплей`)
};

const ru_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Геймплей LEGO Star Wars`)
};

const uk_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Геймплей LEGO Star Wars`)
};

const ar_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لعب LEGO Star Wars`)
};

const hi_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars गेमप्ले`)
};

const th_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพเกม LEGO Star Wars`)
};

const ja_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars ゲームプレイ`)
};

const zh_cn2_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乐高星球大战游戏画面`)
};

const zh_hant1_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`樂高星際大戰遊戲畫面`)
};

const ko_misc_posts_gameplayalt1 = /** @type {(inputs: Misc_Posts_Gameplayalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars 게임플레이`)
};

/**
* | output |
* | --- |
* | "LEGO Star Wars Gameplay" |
*
* @param {Misc_Posts_Gameplayalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_gameplayalt1 = /** @type {((inputs?: Misc_Posts_Gameplayalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Gameplayalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_gameplayalt1(inputs)
	if (locale === "ms") return ms_misc_posts_gameplayalt1(inputs)
	if (locale === "da") return da_misc_posts_gameplayalt1(inputs)
	if (locale === "de") return de_misc_posts_gameplayalt1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_gameplayalt1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_gameplayalt1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_gameplayalt1(inputs)
	if (locale === "fil") return fil_misc_posts_gameplayalt1(inputs)
	if (locale === "fr") return fr_misc_posts_gameplayalt1(inputs)
	if (locale === "it") return it_misc_posts_gameplayalt1(inputs)
	if (locale === "hu") return hu_misc_posts_gameplayalt1(inputs)
	if (locale === "nl") return nl_misc_posts_gameplayalt1(inputs)
	if (locale === "no") return no_misc_posts_gameplayalt1(inputs)
	if (locale === "pl") return pl_misc_posts_gameplayalt1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_gameplayalt1(inputs)
	if (locale === "pt") return pt_misc_posts_gameplayalt1(inputs)
	if (locale === "ro") return ro_misc_posts_gameplayalt1(inputs)
	if (locale === "fi") return fi_misc_posts_gameplayalt1(inputs)
	if (locale === "sv") return sv_misc_posts_gameplayalt1(inputs)
	if (locale === "vi") return vi_misc_posts_gameplayalt1(inputs)
	if (locale === "tr") return tr_misc_posts_gameplayalt1(inputs)
	if (locale === "cs") return cs_misc_posts_gameplayalt1(inputs)
	if (locale === "bg") return bg_misc_posts_gameplayalt1(inputs)
	if (locale === "ru") return ru_misc_posts_gameplayalt1(inputs)
	if (locale === "uk") return uk_misc_posts_gameplayalt1(inputs)
	if (locale === "ar") return ar_misc_posts_gameplayalt1(inputs)
	if (locale === "hi") return hi_misc_posts_gameplayalt1(inputs)
	if (locale === "th") return th_misc_posts_gameplayalt1(inputs)
	if (locale === "ja") return ja_misc_posts_gameplayalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_gameplayalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_gameplayalt1(inputs)
	return ko_misc_posts_gameplayalt1(inputs)
});
export { misc_posts_gameplayalt1 as "misc.posts.gameplayAlt" }